__turbopack_context__.v({
  "button": "CSi_la_button",
  "buttonLabel": "CSi_la_buttonLabel",
  "iconOnly": "CSi_la_iconOnly",
  "lg": "CSi_la_lg",
  "sm": "CSi_la_sm",
  "switch": "CSi_la_switch",
  "switchIcon": "CSi_la_switchIcon",
  "switchInput": "CSi_la_switchInput",
  "switchLabel": "CSi_la_switchLabel",
  "switchSlider": "CSi_la_switchSlider",
  "toggle": "CSi_la_toggle",
});
